// extracted by mini-css-extract-plugin
export default {"bottom":"PushBottom_bottom__NKhv2","bottomTitle":"PushBottom_bottomTitle__vcbsX","backLink":"PushBottom_backLink__gP3B7"};